module.exports = __webpack_public_path__ + "img/loza.461b66ce.png";